import * as React from 'react';
import { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import { updateSnackbar } from '../../stores/SnackbarSlice';
import MuiAlert from '@mui/material/Alert';
import { SnackbarProvider, useSnackbar } from 'notistack';


export default function SimpleSnackbar() {

    const dispatch = useDispatch();
    let { showSnackbar, message, status } = useSelector((state) => state.snackbar.snackbar_vals);
    // const { enqueueSnackbar } = useSnackbar();

    // console.log('---SimpleSnackbar--showSnackbar:', showSnackbar, '---message:' , message, '---status:', status,);

    // const [state, setState] = React.useState({
    //     showSnackbar: false,
    //     vertical: 'top',
    //     horizontal: 'center',
    //     // message: 'ccc'
    //   });
      
    //   const { vertical, horizontal} = state;
    
      const handleClick = (newState) => () => {
        // setState({ showSnackbar: true, ...newState });
        // message = 'bbb'
        // setState({ message: 'bbb2', ...newState });
        // showSnackbar = true;
        dispatch(updateSnackbar({showSnackbar: true, message: 'Test msg', status: 'info'}))
      };
    
      const handleClose = () => {
        // setState({ ...state, showSnackbar: false });
        // showSnackbar = false;
        dispatch(updateSnackbar({showSnackbar: false}))
        // enqueueSnackbar('This is a success message!', 'success');
      };

    //   if (!message) {
    //     message = 'qwqw'
    //   }

    useEffect(() => {
        if(showSnackbar) {
            handleTimeuOuts();
        }
    }, [showSnackbar])

    const handleTimeuOuts = () => {
        setTimeout(() => {
            handleClose();
        }, 5000);
    }

  const action = (
    <React.Fragment>
      {/* <Button color="secondary" size="small" onClick={handleClose}>
        UNDO
      </Button> */}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  // const MyButton = () => {
  //   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  //   return <Button onClick={() => enqueueSnackbar('I love hooks', {variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'center' }, autoHideDuration: 5000})} >Show snackbar</Button>;
  // };

  return (
    <div>

      {/* <Button
        onClick={handleClick({
          vertical: 'top',
          horizontal: 'center',
        })}
      >
        Top-Center
      </Button> */}

        { 
        showSnackbar &&
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center'}}
            open={showSnackbar}
            autoHideDuration={5000}
            // onClose={handleClose}
            // message={message}
            action={action}
            key={'top' + 'center'}
        >
            <Alert onClose={handleClose} severity={status} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
        }

        {/* <SnackbarProvider>
        <MyButton />
        </SnackbarProvider> */}

    </div>
  );
}